const STORAGE_KEY = "todocenter.designPreview";

const TAGS = [
  { Key: "Unread", Text: "未读" },
  { Key: "Timeout", Text: "超时", Style: { color: "#fff", background: "#f5222d", borderColor: "#f5222d" } },
  { Key: "CuiBan", Text: "已催办" },
  { Key: "Important", Text: "重点" },
];

const PROCESS_NAMES = [
  { Id: "approval$budget", Count: 4, ProcessNameML: "预算追加申请", ModuleId: "approval", ProcessName: "budget_adjust" },
  { Id: "approval$contract", Count: 3, ProcessNameML: "合同用印审批", ModuleId: "approval", ProcessName: "contract_seal" },
  { Id: "approval$purchase", Count: 5, ProcessNameML: "采购付款审批", ModuleId: "approval", ProcessName: "purchase_payment" },
  { Id: "approval$travel", Count: 2, ProcessNameML: "差旅报销审批", ModuleId: "approval", ProcessName: "travel_expense" },
  { Id: "approval$vendor", Count: 2, ProcessNameML: "供应商准入审批", ModuleId: "approval", ProcessName: "vendor_onboarding" },
  { Id: "approval$risk", Count: 1, ProcessNameML: "风险事项报备", ModuleId: "approval", ProcessName: "risk_report" },
];

const MODULES = [
  {
    Id: "@@approval",
    Name: "智能审批",
    Count: 17,
    Childs: [
      makeModule("finance", "财务与预算", ["budget_adjust", "travel_expense"], 6),
      makeModule("contract", "合同与用印", ["contract_seal"], 3),
      makeModule("purchase", "采购与供应商", ["purchase_payment", "vendor_onboarding"], 7),
      makeModule("risk", "风控合规", ["risk_report"], 1),
    ],
    Processes: [],
    ProcessesIncludeChildren: PROCESS_NAMES,
  },
];

const PROCESS_TREE = [
  {
    Id: "root",
    Name: "智能审批流程",
    Categories: [
      makeProcessCategory("finance-init", "财务与预算", [
        ["budget_adjust", "预算追加申请"],
        ["travel_expense", "差旅报销审批"],
        ["expense_reimburse", "费用报销申请"],
      ]),
      makeProcessCategory("contract-init", "合同与用印", [
        ["contract_seal", "合同用印审批"],
        ["contract_archive", "合同归档申请"],
      ]),
      makeProcessCategory("purchase-init", "采购与供应商", [
        ["purchase_payment", "采购付款审批"],
        ["vendor_onboarding", "供应商准入审批"],
      ]),
      makeProcessCategory("risk-init", "风控合规", [
        ["risk_report", "风险事项报备"],
        ["policy_exception", "制度例外审批"],
      ]),
    ],
    Processes: [],
  },
];

const TODO_ITEMS = [
  makeItem({
    id: "AP-202606-001",
    node: "node-001",
    process: "采购付款审批",
    processKey: "purchase_payment",
    step: "部门负责人审批",
    subject: "市场部 6 月品牌活动物料采购付款，供应商已完成交付验收",
    formNo: "PAY-2026-0619-001",
    sender: "王明",
    dept: "总部/市场部",
    created: "2026-06-19 09:32:18",
    received: "2026-06-20 08:45:11",
    tags: ["Unread", "Timeout", "Important"],
    riskLevel: 2,
    riskText: "付款金额超过部门月度预算 18%",
    fields: [
      ["付款金额", "86,500 元"],
      ["供应商", "启明数字服务"],
      ["预算科目", "品牌活动费"],
      ["是否验收", "已验收"],
    ],
    extra: [
      ["AI建议", "建议补充预算调整说明后审批"],
      ["关联单据", "采购申请 CG-2026-0528-017"],
    ],
    done: ["陈琳", "周航"],
    favorite: true,
  }),
  makeItem({
    id: "AP-202606-002",
    node: "node-002",
    process: "合同用印审批",
    processKey: "contract_seal",
    step: "法务复核",
    subject: "年度数据服务框架协议用印，合同金额 24 万元，付款节点按季度验收",
    formNo: "SEAL-2026-0620-004",
    sender: "赵敏",
    dept: "总部/销售运营部",
    created: "2026-06-20 10:22:05",
    received: "2026-06-20 15:18:33",
    tags: ["Unread"],
    riskLevel: 1,
    riskText: "合同付款节点与验收节点存在跨期",
    fields: [
      ["合同金额", "240,000 元"],
      ["相对方", "蓝石科技"],
      ["合同类型", "数据服务"],
      ["用印份数", "2 份"],
    ],
    extra: [["AI建议", "关注服务交付验收标准是否明确"]],
    now: [{ StepName: "法务复核", UserName: "任威" }],
  }),
  makeItem({
    id: "AP-202606-003",
    node: "node-003",
    process: "预算追加申请",
    processKey: "budget_adjust",
    step: "财务 BP 审核",
    subject: "华东区渠道拓展项目追加预算 12 万元，用于线下客户共创工作坊",
    formNo: "BUD-2026-0620-009",
    sender: "李娜",
    dept: "华东区/渠道发展部",
    created: "2026-06-20 13:14:29",
    received: "2026-06-20 16:05:42",
    tags: ["Unread", "Important"],
    riskLevel: 0,
    riskText: "预算用途完整，历史同类项目 ROI 达标",
    fields: [
      ["追加金额", "120,000 元"],
      ["项目周期", "2026-07 至 2026-09"],
      ["预算来源", "市场储备金"],
      ["预计产出", "新增 18 家线索客户"],
    ],
    extra: [["AI建议", "可要求补充阶段性效果复盘节点"]],
    done: ["宋阳"],
  }),
  makeItem({
    id: "AP-202606-004",
    node: "node-004",
    process: "供应商准入审批",
    processKey: "vendor_onboarding",
    step: "采购经理审批",
    subject: "新增智能客服实施供应商，拟用于两个区域试点项目",
    formNo: "VEN-2026-0618-012",
    sender: "陈杰",
    dept: "总部/数字化部",
    created: "2026-06-18 17:43:20",
    received: "2026-06-19 09:08:11",
    tags: ["CuiBan", "Timeout"],
    riskLevel: 1,
    riskText: "供应商成立年限不足 2 年",
    fields: [
      ["供应商名称", "星河智能"],
      ["准入类型", "项目型供应商"],
      ["预计合作额", "180,000 元"],
      ["资质状态", "待补充"],
    ],
    extra: [["AI建议", "建议增加试点期退出条款"]],
    done: ["韩悦", "钱峰", "杜若"],
  }),
  makeItem({
    id: "AP-202606-005",
    node: "node-005",
    process: "差旅报销审批",
    processKey: "travel_expense",
    step: "直属上级审批",
    subject: "宁波客户现场调研差旅报销，含高铁、住宿与市内交通",
    formNo: "EXP-2026-0620-018",
    sender: "孙浩",
    dept: "客户成功部/华东组",
    created: "2026-06-20 08:21:10",
    received: "2026-06-20 09:15:08",
    tags: ["Unread"],
    fields: [
      ["报销金额", "3,286 元"],
      ["出差城市", "宁波"],
      ["出差天数", "2 天"],
      ["客户名称", "宁波智造集团"],
    ],
    extra: [["AI建议", "票据齐全，可快速审批"]],
  }),
];

const SENT_ITEMS = [
  makeItem({
    id: "AP-202606-101",
    node: "node-101",
    process: "预算追加申请",
    processKey: "budget_adjust",
    step: "总经理审批",
    subject: "区域客户体验中心搭建预算追加申请",
    formNo: "BUD-2026-0617-002",
    sender: "设计预览用户",
    dept: "总部/流程管理部",
    created: "2026-06-17 11:20:00",
    received: "2026-06-17 11:20:00",
    instanceState: 0,
    now: [
      { StepName: "总经理审批", UserName: "林总" },
      { StepName: "财务会签", UserName: "唐倩" },
    ],
    fields: [
      ["追加金额", "320,000 元"],
      ["业务目标", "提升大客户接待能力"],
      ["预算周期", "2026 Q3"],
      ["发起部门", "流程管理部"],
    ],
  }),
  makeItem({
    id: "AP-202606-102",
    node: "node-102",
    process: "风险事项报备",
    processKey: "risk_report",
    step: "已完结",
    subject: "项目延期风险报备与客户沟通计划",
    formNo: "RISK-2026-0616-006",
    sender: "设计预览用户",
    dept: "总部/流程管理部",
    created: "2026-06-16 09:40:00",
    received: "2026-06-16 09:40:00",
    instanceState: 1,
    fields: [
      ["风险等级", "中"],
      ["影响范围", "2 个客户项目"],
      ["缓释措施", "增派实施顾问"],
      ["预计关闭", "2026-06-28"],
    ],
  }),
];

const DONE_ITEMS = [
  makeItem({
    id: "AP-202606-201",
    node: "node-201",
    process: "合同用印审批",
    processKey: "contract_seal",
    step: "已处理",
    subject: "云平台年度续费合同用印，已完成法务复核",
    formNo: "SEAL-2026-0619-008",
    sender: "杨帆",
    dept: "总部/IT 部",
    created: "2026-06-19 10:05:00",
    received: "2026-06-19 14:35:00",
    instanceState: 0,
    fields: [
      ["合同金额", "98,000 元"],
      ["合同周期", "12 个月"],
      ["用印类型", "合同章"],
      ["处理结论", "同意"],
    ],
  }),
  makeItem({
    id: "AP-202606-202",
    node: "node-202",
    process: "差旅报销审批",
    processKey: "travel_expense",
    step: "已处理",
    subject: "北京客户拜访差旅报销",
    formNo: "EXP-2026-0618-022",
    sender: "刘洋",
    dept: "北区/销售一部",
    created: "2026-06-18 18:25:00",
    received: "2026-06-19 08:55:00",
    instanceState: 1,
    fields: [
      ["报销金额", "4,186 元"],
      ["处理结论", "同意"],
      ["票据状态", "已核验"],
      ["支付状态", "待付款"],
    ],
  }),
];

const COPY_ITEMS = [
  makeItem({
    id: "AP-202606-301",
    node: "node-301",
    process: "采购付款审批",
    processKey: "purchase_payment",
    step: "抄送",
    subject: "华南区设备采购付款审批已提交，需关注预算占用",
    formNo: "PAY-2026-0619-030",
    sender: "许诺",
    dept: "华南区/运营部",
    created: "2026-06-19 16:30:00",
    received: "2026-06-20 09:00:00",
    instanceState: 0,
    tags: ["Unread", "Important"],
    fields: [
      ["付款金额", "156,800 元"],
      ["抄送原因", "预算关注"],
      ["供应商", "南方设备"],
      ["当前节点", "财务复核"],
    ],
  }),
  makeItem({
    id: "AP-202606-302",
    node: "node-302",
    process: "供应商准入审批",
    processKey: "vendor_onboarding",
    step: "抄送",
    subject: "新增咨询供应商准入审批",
    formNo: "VEN-2026-0619-007",
    sender: "陆宁",
    dept: "总部/战略部",
    created: "2026-06-19 13:42:00",
    received: "2026-06-19 13:45:00",
    instanceState: 1,
    tags: [],
    fields: [
      ["供应商", "远见咨询"],
      ["准入等级", "B 类"],
      ["合作范围", "行业研究"],
      ["抄送原因", "知识沉淀"],
    ],
  }),
];

function isDesignPreview() {
  if (process.env.NODE_ENV !== "development") return false;

  let params = new URLSearchParams(window.location.search);
  if (params.get("mock") === "0") {
    localStorage.setItem(STORAGE_KEY, "0");
  }
  if (params.get("mock") === "1") {
    localStorage.setItem(STORAGE_KEY, "1");
  }

  return localStorage.getItem(STORAGE_KEY) !== "0";
}

function designPreviewAdapter(config) {
  window.__TODOCENTER_DESIGN_PREVIEW__ = true;

  return new Promise((resolve) => {
    let body = resolveMockBody(config);
    setTimeout(() => {
      resolve({
        data: body,
        status: 200,
        statusText: "OK",
        headers: {},
        config,
        request: {},
      });
    }, 120);
  });
}

function resolveMockBody(config) {
  let { path, searchParams } = parseUrl(config.url);
  let payload = parsePayload(config.data);
  let pathname = path.toLowerCase();

  if (pathname === "/api/page/loadconfig") {
    return {
      data: {
        Warning: "",
        Cust: "design",
        Features: {
          Suspend: true,
          Risks: true,
          Favorite: true,
          KeyFields: true,
          InitiateFromPC: true,
          InitiateFromMobile: true,
        },
        JJUsers: [
          { LoginName: "li.na", Name: "李娜" },
          { LoginName: "chen.jie", Name: "陈杰" },
        ],
      },
    };
  }

  if (pathname === "/options_sapi.axd") {
    return {
      app_menu_width: "200",
      app_menu_icon_show: "levelOne",
      app_menu_icon_default: "el-icon-menu",
      app_menu_theme: "light",
      app_menu_collapse_enableSwitch: "1",
      app_menu_collapse_collapsed: "0",
      "Agree.EnableRemark": "0",
      "Agree.NoConfirm": "0",
      "v3.tabs.pc": "init,timeout:催办,todo,sent,did,copy,fav,handover",
      "v3.tabs.mobile": "init,timeout:催办,todo,sent,did,copy,fav,handover",
      "v3.todo.invisible_tags": "",
      "v3.class_position": "left",
      "v3.mobile.tools_layout": "2",
      "Initiate.FromPC.Width1": 220,
      "Initiate.FromPC.Width2": 160,
      "v3.pc.pager": "10,10,20,50",
    };
  }

  if (pathname === "/api/page/getloginname") {
    return {
      name: "design.viewer",
      LoginName: "design.viewer",
      UserName: "设计预览用户",
    };
  }

  if (pathname === "/api/page/calccounts") {
    return {
      data: {
        Items: (Array.isArray(payload) ? payload : []).map((target) => countByTarget(target)),
      },
    };
  }

  if (pathname === "/api/processsettings/processtree") {
    return { data: PROCESS_TREE };
  }

  if (pathname === "/api/page/queryusernames") {
    return {
      data: {
        Items: ["王明(wang.ming)", "李娜(li.na)", "赵敏(zhao.min)", "陈杰(chen.jie)"],
      },
    };
  }

  if (pathname === "/api/page/gettodo") {
    let items = filterList(TODO_ITEMS, payload);
    if (document.location.hash.includes("/v3/timeout") && !hasTagQuery(payload)) {
      items = items.filter((item) => hasInfoTag(item.TodoInfo, "Timeout"));
    }
    if (searchParams.has("count")) return countResult(items);
    return listResult(items, payload);
  }

  if (pathname === "/api/page/getmysend") {
    return listResult(filterList(SENT_ITEMS, payload), payload);
  }

  if (pathname === "/api/page/getyiban") {
    return listResult(filterList(DONE_ITEMS, payload), payload);
  }

  if (pathname === "/api/page/getchaosong") {
    return listResult(filterList(COPY_ITEMS, payload), payload);
  }

  if (pathname === "/api/page/getfav") {
    let items = [...TODO_ITEMS, ...SENT_ITEMS, ...DONE_ITEMS, ...COPY_ITEMS].filter((item) => item.IsFavorite);
    return listResult(filterList(items, payload), payload);
  }

  if (pathname === "/api/cuiban/cuiban") {
    return {
      code: 0,
      targets: payload.query === 1 ? [
        { Name: "任威" },
        { Name: "唐倩" },
        { Name: "外部协同人", Error: "该用户未绑定提醒渠道" },
      ] : [],
    };
  }

  if (/^\/api\/manage\//i.test(path) || /^\/api\/module\//i.test(path) || /^\/api\/assistancesettings\//i.test(path)) {
    return { code: 0, data: {}, message: "design preview ok" };
  }

  return { code: 0, data: {} };
}

function makeModule(id, name, processKeys, count) {
  let processes = PROCESS_NAMES.filter((item) => processKeys.includes(item.ProcessName));
  return {
    Id: id,
    Name: name,
    Count: count,
    Childs: [],
    Processes: processes,
    ProcessesIncludeChildren: processes,
    ClassifyId: id,
    ModuleId: "approval",
    ProcessNames: processes.map((item) => item.ProcessName).join(";"),
  };
}

function makeProcessCategory(id, name, processes) {
  return {
    Id: id,
    Name: name,
    Categories: [],
    Processes: processes.map(([processId, alias]) => ({
      ProcessId: processId,
      Alias: alias,
      InitiateUrl: `/#/test?process=${processId}`,
    })),
  };
}

function makeItem(config) {
  let risks = config.riskText ? [{ Name: config.riskText, Level: config.riskLevel || 0 }] : [];
  let info = makeInfo(config.received, config.tags || [], risks);

  return {
    Id: config.id,
    ModuleNodeId: config.node,
    ModuleId: "approval",
    ProcessName: config.process,
    ProcessKey: config.processKey,
    StepName: config.step,
    Subject: config.subject,
    FormNumber: config.formNo,
    ProcessInstanceDate: config.created,
    Sender: config.sender,
    SenderDeptNames: config.dept,
    SenderAvatar: "",
    InstanceState: config.instanceState || 0,
    KeyFields: toGridFields(config.fields || []),
    FormComponentValues: toPlainFields(config.extra || []),
    TodoInfo: info,
    DoneInfo: makeInfo(config.received, [], []),
    CopyInfo: makeInfo(config.received, config.tags || [], []),
    NowExaminePeople: config.now || [],
    DoneNodes: (config.done || []).map((UserName) => ({ UserName })),
    AllowAgree: config.allowAgree !== false,
    AllowReturn2: config.allowReturn !== false,
    AllowDeleteTodo: config.allowDelete !== false,
    AllowCopy: config.allowCopy !== false,
    AllowAssign: config.allowAssign !== false,
    AllowCuiBan: true,
    IsFavorite: !!config.favorite,
    IsSuspended: !!config.suspended,
    FormUrl: "/#/test",
  };
}

function makeInfo(startTime, tagKeys, risks) {
  return {
    StartTime: startTime,
    Tags: tagKeys.map((key) => TAGS.find((tag) => tag.Key === key)).filter(Boolean),
    Risks: risks,
    MaxRiskLevel: risks.length ? Math.max(...risks.map((risk) => risk.Level)) : 0,
  };
}

function toGridFields(fields) {
  return fields.map(([Name, Value], index) => ({
    Name,
    Value,
    Grid: `${(index % 2) + 1},${Math.floor(index / 2) + 1}`,
  }));
}

function toPlainFields(fields) {
  return fields.map(([Name, Value]) => ({ Name, Value }));
}

function parseUrl(url) {
  let parsed = new URL(url || "/", "http://design-preview.local");
  return {
    path: parsed.pathname,
    searchParams: parsed.searchParams,
  };
}

function parsePayload(data) {
  if (!data) return {};
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (error) {
      return {};
    }
  }
  return data;
}

function countByTarget(target) {
  if (target.Target === "copy") return filterList(COPY_ITEMS, target.Query || {}).length;
  return filterList(TODO_ITEMS, target.Query || {}).length;
}

function countResult(items) {
  return {
    data: {
      Count: items.length,
      Data: [],
      Other: makeOther(),
    },
  };
}

function listResult(items, payload) {
  let page = Number(payload.Page || 1);
  let num = Number(payload.Num || 10);
  let start = Math.max(page - 1, 0) * num;
  let data = num === 0 ? [] : items.slice(start, start + num);

  return {
    data: {
      Count: items.length,
      Data: data,
      Other: makeOther(),
    },
  };
}

function makeOther() {
  return {
    Tags: TAGS,
    Modules: MODULES,
    ProcessNames: PROCESS_NAMES,
  };
}

function filterList(items, query = {}) {
  let result = [...items];

  if (query.Suspended === true) {
    result = result.filter((item) => item.IsSuspended);
  } else if (query.Suspended === false) {
    result = result.filter((item) => !item.IsSuspended);
  }

  if (Array.isArray(query.Tags) && query.Tags.length) {
    result = result.filter((item) => {
      return query.Tags.every((tag) => {
        return hasInfoTag(item.TodoInfo, tag) || hasInfoTag(item.CopyInfo, tag);
      });
    });
  }

  if (query.RiskLevel !== null && query.RiskLevel !== undefined && query.RiskLevel !== "__whole") {
    result = result.filter((item) => item.TodoInfo.MaxRiskLevel === Number(query.RiskLevel));
  }

  if (query.State !== null && query.State !== undefined && query.State !== "__whole") {
    result = result.filter((item) => item.InstanceState === Number(query.State));
  }

  if (Array.isArray(query.ProcessNames2) && query.ProcessNames2.length) {
    let processKeys = query.ProcessNames2.map((item) => item.ProcessName);
    result = result.filter((item) => processKeys.includes(item.ProcessKey));
  }

  let keyword = [query.Key, query.Title, query.FormNumber, query.SendUser].filter(Boolean).join(" ");
  if (keyword) {
    result = result.filter((item) => {
      let haystack = [
        item.ProcessName,
        item.Subject,
        item.FormNumber,
        item.Sender,
        item.SenderDeptNames,
      ].join(" ");
      return keyword.split(/\s+/).every((word) => haystack.includes(word));
    });
  }

  if (query.DescSort === false) {
    result.reverse();
  }

  return result;
}

function hasInfoTag(info, tag) {
  return (info.Tags || []).some((item) => item.Key === tag);
}

function hasTagQuery(payload) {
  return Array.isArray(payload.Tags) && payload.Tags.length > 0;
}

export {
  designPreviewAdapter,
  isDesignPreview,
};
